// @flow

export const DEFAULT_DATE_FORMAT = 'YYYY-MM-DD';
export const SLASH_DATE_FORMAT = 'M/D/yyyy';
